import { useTreeContext } from "../../../context/TreeDataContext";
import React, { useEffect, useState } from "react";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";
import JsonTextareaField from "../../../components/BuilderComponents/JsonTextareaField";
import Textarea from "../../../components/FormComponents/Textarea";

const RecordviewTemplateEditor = ({ file, templateData, setTemplateData }) => {
  const { templateExplorerData } = useTreeContext();
  const [allMongoTemplates, setAllMongoTemplates] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);

  const { isDirty, markClean } = useDirtyChecker(templateData);
  const [isSaving, setIsSaving] = useState(false);

  const handleTemplateChange = (key, value) => {
    setTemplateData((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const getMongoTemplates = () => {
    const mongo = templateExplorerData.find((t) => t.id === "mongo-template");
    return mongo?.items || [];
  };

  const handleChangeOtherTemplates = (newSelected) => {
    const ids = newSelected.map((t) => t.id);
    setSelectedTemplates(newSelected);
    handleTemplateChange("other_mongo_collections", ids);
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const { message } = await axiosInstance.patch(`/recordview-template/${file.id}`, templateData);
      toastSuccess(message);
      markClean();
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    const mongoTemplates = getMongoTemplates();
    setAllMongoTemplates(mongoTemplates);
    const selected = mongoTemplates.filter((t) => templateData?.other_mongo_collections?.includes(t.id));
    setSelectedTemplates(selected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateExplorerData, templateData?.other_mongo_collections]);

  return (
    <div className="d_flex flex_column">
      <GenericActionBar
        path={
          <div>
            <em>Recordview Templates</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSave
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />

      <div className="template_form_outer builder_form">
        <div className="d_flex gap_3">
          <SingleSelectBox
            selectedData={templateData?.base_mongo_collection}
            options={getMongoTemplates()}
            onChange={(obj) => handleTemplateChange("base_mongo_collection", obj.id)}
            label="Base Mongo Collection"
          />

          <MultiSelectBox
            options={allMongoTemplates}
            selectedData={selectedTemplates}
            onChange={handleChangeOtherTemplates}
            label="Other Collections"
          />
        </div>

        <JsonTextareaField
          label="Fields"
          jsonValue={templateData?.fields || []}
          onChange={(parsed) => handleTemplateChange("fields", parsed)}
        />

        <Textarea
          label="Pipeline Query"
          value={templateData.pipeline_query}
          onChange={(e) => handleTemplateChange("pipeline_query", e.target.value)}
          placeholder="Enter MongoDB aggregation pipeline"
          style={{ minHeight: "200px" }}
        />
      </div>
    </div>
  );
};

export default RecordviewTemplateEditor;
